// extracted by mini-css-extract-plugin
export default {"footer":"SocialModal_footer__-AmWM","cancel_btn":"SocialModal_cancel_btn__2yOW2","icon_wrap":"SocialModal_icon_wrap__-jfVn"};